document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('formModal');
    const form  = modal?.querySelector('form');
    if (form) {
        form.addEventListener('submit', () => {
            try {
                // Localiza la instancia del editor asociada a texto_email
                const textarea = form.querySelector('textarea[name="texto_email"]');
                if (!textarea) return;
                const ed =
                (window.CKTOOLS && Object.values(CKTOOLS.editors)
                    .find(e => e?.sourceElement === textarea))
                || null;
                if (ed) textarea.value = ed.getData();
            } catch (_) {}
        });
    }
    const openBtn = document.getElementById('openCreateDocModal');
    const closeBtn = document.getElementById('closeModal');
    const destinatarioSelect = document.getElementById('destinatarioSelect');

    // --- helpers de visibilidad de contenedores ---
    const containers = {
        grupoLocales: document.getElementById('grupoLocalesContainer'),
        grupoTiendas: document.getElementById('grupoTiendasContainer'),
        categoriaTiendas: document.getElementById('categoriaTiendasContainer'),
    };

    function toggleContainers(value) {
        Object.values(containers).forEach(container => container.style.display = 'none');

        if (value === 'grupo_local') {
            containers.grupoLocales.style.display = 'block';
        } else if (value === 'grupo_tienda') {
            containers.grupoTiendas.style.display = 'block';
        } else if (value === 'categoria_tienda' || value === 'locales_por_categoria_tienda') {
            containers.categoriaTiendas.style.display = 'block';
        }
    }

    // --- abrir/cerrar modal crear ---
    if (openBtn && closeBtn && modal && destinatarioSelect) {
        openBtn.addEventListener('click', async () => {
            modal.classList.remove('hidden');
            document.getElementById('nuevoArchivosContainer').innerHTML = '';
            // Limpia el campo y flags: apertura de NUEVO => debe ir vacío
            const ta = document.querySelector('#formModal textarea[name="texto_email"]');
            if (ta) {
              ta.value = '';                          // ← vacío real del textarea
              delete ta.dataset.ckInit;               // ← permite re-init
              ta.removeAttribute('data-ck-init');
            }

            if (window.CKTOOLS) {
                CKTOOLS.init('#formModal textarea[name="texto_email"]').then(() => {
                    // Fuerza vacío en la instancia por si algún autosave quedó
                    const ed = Object.values(CKTOOLS.editors).find(e => e?.sourceElement === ta);
                    if (ed) ed.setData('');
                });
            }

        });
        closeBtn.addEventListener('click', async () => {
            modal.classList.add('hidden');
            // 1) resetea el form
            const form = modal.querySelector('form');
            if (form) form.reset();
            // 2) limpia el textarea (valor + flags)
            const ta = modal.querySelector('textarea[name="texto_email"]');
            if (ta) {
              ta.value = '';
              delete ta.dataset.ckInit;
              ta.removeAttribute('data-ck-init');
            }
            // 3) destruye editores y quita flags internos
            if (window.CKTOOLS) await CKTOOLS.destroyAll();
        });
    }

    // --- handler edición: RELLENA y PRESELECCIONA ---
    document.querySelectorAll('.openEditDocModal').forEach(btn => {
        btn.addEventListener('click', async () => {
            const id = btn.dataset.id;

            const res = await fetch(`/admin/documentos/${id}/edit`);
            const data = await res.json();

            // 1) Rellenar cabecera y campos básicos
            const form = document.querySelector('#formModal form');
            document.querySelector('#formModal h2').textContent = 'Editar Documento';
            form.action = `/admin/documentos/${id}`;
            document.querySelector('#formModal input[name="_method"]').value = 'PUT';
            document.querySelector('#formModal input[name="titulo"]').value = data.titulo || '';
            document.querySelector('#formModal textarea[name="descripcion"]').value = data.descripcion || '';
            document.querySelector('#formModal textarea[name="texto_email"]').value = data.texto_email || '';

            // 2) Destinatario + mostrar contenedor correcto
            const selDest = document.querySelector('#formModal select[name="destinatario"]');
            selDest.value = data.destinatario || '';
            toggleContainers(selDest.value);

            // 3) destinatario_config (viene string -> parse seguro)
            const safeParse = (x) => {
                try { return typeof x === 'string' ? JSON.parse(x || '{}') : (x || {}); }
                catch { return {}; }
            };
            const cfg = safeParse(data.destinatario_config || {});

            // 4) selects a preseleccionar
            const selGrupoLocales = document.querySelector('select[name="grupo_locales[]"]');
            const selGrupoTiendas = document.querySelector('select[name="grupo_tiendas[]"]');
            const selCategoria    = document.querySelector('select[name="categoria_tienda"]');

            const clearMulti = (sel) => sel && Array.from(sel.options).forEach(o => { o.selected = false; });
            const selectMultiValues = (sel, values = []) => {
                if (!sel) return;
                const set = new Set((values || []).map(String));
                Array.from(sel.options).forEach(o => { o.selected = set.has(String(o.value)); });
            };

            // Limpia previas
            clearMulti(selGrupoLocales);
            clearMulti(selGrupoTiendas);
            if (selCategoria) selCategoria.value = '';

            // 5) Aplica según el tipo
            switch (data.destinatario) {
                case 'grupo_local':
                    // p.ej. {"grupo_local":["1","2","3","4"]}
                    selectMultiValues(selGrupoLocales, cfg.grupo_local || []);
                    break;

                case 'grupo_tienda':
                    // p.ej. {"grupo_tienda":["179"]}
                    selectMultiValues(selGrupoTiendas, cfg.grupo_tienda || []);
                    break;

                case 'categoria_tienda':
                case 'locales_por_categoria_tienda':
                    if (selCategoria && cfg.categoria_tienda) {
                        selCategoria.value = String(cfg.categoria_tienda);
                    }
                    break;

                default:
                    // local / tienda / ambos no requieren selección adicional
                    break;
            }

            // 6) Notificar a plugins (Select2/Choices...), si existieran
            if (selGrupoLocales) selGrupoLocales.dispatchEvent(new Event('change'));
            if (selGrupoTiendas) selGrupoTiendas.dispatchEvent(new Event('change'));
            if (selCategoria)    selCategoria.dispatchEvent(new Event('change'));

            // 7) Quitar required del archivo en edición
            const archivosInput = document.querySelector('#formModal input[name="archivos[]"]');
            if (archivosInput) archivosInput.removeAttribute('required');

            // 8) Limpiar contenedor de nuevos archivos y mostrar modal
            document.getElementById('nuevoArchivosContainer').innerHTML = '';
            document.getElementById('formModal').classList.remove('hidden');
            // Inicializa CKEditor para texto_email cuando el modal ya es visible
            if (window.CKTOOLS) {
              CKTOOLS.init('#formModal textarea[name="texto_email"]');
            }
        });
    });

    // --- eliminar documento ---
    $('.deleteDoc').on('click', function (e) {
        e.preventDefault();
        const id = $(this).data('id');

        Swal.fire({
            title: '¿Estás seguro?',
            text: 'Esta acción no se puede deshacer.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6b7280',
            confirmButtonText: 'Sí, eliminar'
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    url: `/admin/documentos/${id}`,
                    method: 'POST',
                    data: { _method: 'DELETE', _token: $('meta[name="csrf-token"]').attr('content') },
                    success: function (response) {
                        Swal.fire('Eliminado', response.success || 'El registro ha sido eliminado.', 'success')
                            .then(() => location.reload());
                    },
                    error: function () {
                        Swal.fire('Error', 'No se pudo eliminar el registro.', 'error');
                    }
                });
            }
        });
    });

    // --- eliminar archivo ---
    $('.deleteArchivo').on('click', function (e) {
        e.preventDefault();
        const id = $(this).data('id');

        Swal.fire({
            title: '¿Estás seguro?',
            text: 'Esta acción no se puede deshacer.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6b7280',
            confirmButtonText: 'Sí, eliminar'
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    url: `/admin/documentos/archivo/${id}`,
                    method: 'POST',
                    data: { _method: 'DELETE', _token: $('meta[name="csrf-token"]').attr('content') },
                    success: function (response) {
                        console.log(response);
                        Swal.fire('Eliminado', response.success || 'El registro ha sido eliminado.', 'success')
                            .then(() => location.reload());
                    },
                    error: function () {
                        Swal.fire('Error', 'No se pudo eliminar el registro.', 'error');
                    }
                });
            }
        });
    });

    // --- añadir inputs de archivo (protegido sin cortar el script) ---
    const addArchivoBtn = document.getElementById('addArchivoBtn');
    const nuevoArchivosContainer = document.getElementById('nuevoArchivosContainer');
    if (addArchivoBtn && nuevoArchivosContainer) {
        addArchivoBtn.addEventListener('click', () => {
            const div = document.createElement('div');
            div.classList.add('d-flex', 'align-items-center', 'mb-2');
            div.innerHTML = `
                <input type="file" name="archivos[]" accept="application/pdf" class="form-control me-2" required>
                <button type="button" class="btn btn-outline-danger eliminar-nuevo-archivo">Eliminar</button>
            `;
            nuevoArchivosContainer.appendChild(div);
        });

        nuevoArchivosContainer.addEventListener('click', (e) => {
            if (e.target.classList.contains('eliminar-nuevo-archivo')) {
                e.target.parentElement.remove();
            }
        });
    }

    // --- change del select destinatario (creación) ---
    if (destinatarioSelect) {
        destinatarioSelect.addEventListener('change', (e) => {
            toggleContainers(e.target.value);
        });

        // Inicializar por si ya hay un valor cargado
        toggleContainers(destinatarioSelect.value);
    }

    // --- listado de envíos ---
    let modalPollTimer = null;
    let currentModalDocId = null;

    // Helper: pinta el header con métricas y botón
    function renderListadoHeader({ documento, envios, destinatarios, meta, pendientes }) {
        const header = document.getElementById('listadoEnviadosHeader');
        header.innerHTML = '';

        // --- Normalizaciones ---
        const toId = (v) => Number.parseInt(v, 10);
        const destinatariosIds = Array.isArray(destinatarios) ? destinatarios.map(toId).filter(Number.isFinite) : [];

        const haveTargetList = Array.isArray(destinatarios) && destinatariosIds.length >= 0;
        const afectados = meta?.afectados ?? (haveTargetList ? destinatariosIds.length : null);

        const conEnvio = meta?.con_envio ?? (envios || []).filter(e => e.enviado == 1).length;
        const enProceso = meta?.en_proceso ?? (envios || []).filter(e => e.enviado == 0 && !e.error_log).length;

        const pendientesIds = Array.isArray(pendientes)
            ? pendientes.map(toId).filter(Number.isFinite)
            : (haveTargetList ? destinatariosIds.filter(id => !(envios || []).some(e => toId(e.user_id) === id)) : []);

        const pendientesCount = meta?.sin_registro ?? pendientesIds.length;
        const canAccion = haveTargetList && pendientesCount > 0 && enProceso === 0;
        const num = (n) => (typeof n === 'number' ? n : '—');

        // 🔹 Sacar las tandas de envío distintas de los envíos
        const tandasSet = new Set(
            (envios || [])
                .map(e => e.tanda_envio)
                .filter(t => !!t)
        );
        const tandas = Array.from(tandasSet);

        // URLs base
        const baseEmailsUrl = '/admin/emails';
        const baseExcelUrl  = '/admin/emails/exportar';
        const basePdfUrl    = '/admin/emails/exportar-pdf';

        // 🔹 URL para ver tandas en el listado general
        let tandasUrl = baseEmailsUrl;
        const paramsList = new URLSearchParams();

        if (tandas.length === 1) {
            paramsList.append('tanda_envio', tandas[0]);
        } else if (tandas.length > 1) {
            tandas.forEach(t => paramsList.append('tandas[]', t));
        }

        if ([...paramsList.keys()].length > 0) {
            tandasUrl += '?' + paramsList.toString();
        }

        // 🔹 URLs para exportar Excel/PDF (una o varias tandas)
        const hasAnyTanda = tandas.length > 0;
        let excelUrl = null;
        let pdfUrl   = null;

        if (hasAnyTanda) {
            const paramsExport = new URLSearchParams();

            if (tandas.length === 1) {
                paramsExport.append('tanda_envio', tandas[0]);
            } else {
                tandas.forEach(t => paramsExport.append('tandas[]', t));
            }

            const qs = paramsExport.toString();
            excelUrl = baseExcelUrl + '?' + qs;
            pdfUrl   = basePdfUrl   + '?' + qs;
        }

        let alertaEnProceso = '';
        if (enProceso > 0) {
            alertaEnProceso = `
                <div class="alert alert-info py-2 px-3 mb-3 d-flex align-items-center" style="border-radius: 8px; font-size: 13px; background-color: #e8f4fd; border: 1px solid #b6d4fe; color: #084298;">
                    <div class="spinner-border spinner-border-sm me-2 text-primary" role="status" style="width: 1.1rem; height: 1.1rem; flex-shrink: 0;"></div>
                    <div><strong>Envíos en cola:</strong> Hay ${enProceso} correo(s) enviándose en segundo plano. La lista se actualiza automáticamente. Espere a que finalicen antes de enviar pendientes.</div>
                </div>
            `;
        }

        let btnTexto = 'Sin pendientes';
        if (enProceso > 0) {
            btnTexto = 'Envíos en curso…';
        } else if (canAccion) {
            btnTexto = 'Enviar pendientes';
        }

        header.innerHTML = `
            ${alertaEnProceso}
            <div class="enviados-header-grid">
                <div class="metric">
                    <div class="metric-label">Afectados</div>
                    <div class="metric-value">${num(afectados)}</div>
                </div>
                <div class="metric">
                    <div class="metric-label">Con envío registrado</div>
                    <div class="metric-value success">${num(conEnvio)}</div>
                </div>
                <div class="metric">
                    <div class="metric-label">En proceso (cola)</div>
                    <div class="metric-value ${enProceso > 0 ? 'info' : ''}">${num(enProceso)}</div>
                </div>
                <div class="metric">
                    <div class="metric-label">Sin registro / Pendientes</div>
                    <div class="metric-value ${pendientesCount > 0 ? 'warn' : ''}">${num(pendientesCount)}</div>
                </div>
                <div class="action-slot">
                    <button id="btnEnviarPendientes"
                            class="btn-accion"
                            ${canAccion ? '' : 'disabled'}
                            data-docid="${documento?.id ?? ''}">
                        ${btnTexto}
                    </button>
                </div>
            </div>
            <div class="secondary-action-slot">
                <a href="${tandasUrl}"
                target="_blank"
                class="btn-accion btn-secondary"
                style="color:white !important;">
                    Ver tandas de envío
                </a>

                <button id="btnInformePDF"
                        class="btn-accion btn-secondary"
                        ${hasAnyTanda ? '' : 'disabled'}
                        title="${hasAnyTanda ? '' : 'No hay tandas asociadas a este envío'}">
                    Informe de envíos PDF
                </button>

                <button id="btnInformeExcel"
                        class="btn-accion btn-secondary"
                        ${hasAnyTanda ? '' : 'disabled'}
                        title="${hasAnyTanda ? '' : 'No hay tandas asociadas a este envío'}">
                    Informe de envíos EXCEL
                </button>
            </div>
        `;

        // Acción del botón: enviar pendientes
        const btn = document.getElementById('btnEnviarPendientes');
        if (btn && canAccion) {
            btn.addEventListener('click', async () => {
                if (btn.disabled) return;
                btn.disabled = true;
                btn.textContent = 'Encolando…';
                try {
                    const token = document.querySelector('meta[name="csrf-token"]')?.content;
                    if (!token) throw new Error('Token CSRF no encontrado');

                    const res = await fetch(`/admin/documentos/${documento.id}/enviar-pendientes`, {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'X-Requested-With': 'XMLHttpRequest',
                            'X-CSRF-TOKEN': token
                        },
                        body: JSON.stringify({
                            pendientes: pendientesIds   // 👈 array de user_id
                        })
                    });
                    const json = await res.json();
                    btn.textContent = 'Hecho';
                    // Refrescar inmediatamente el modal para ver los nuevos encolados
                    await cargarModalListado(documento.id);
                } catch (e) {
                    console.error(e);
                    btn.textContent = 'Error';
                    btn.disabled = false;
                }
            });
        }

        // 🔹 Acciones de los informes (PDF / EXCEL)
        const btnPdf   = document.getElementById('btnInformePDF');
        const btnExcel = document.getElementById('btnInformeExcel');

        if (btnPdf && pdfUrl) {
            btnPdf.addEventListener('click', () => {
                window.open(pdfUrl, '_blank');
            });
        }

        if (btnExcel && excelUrl) {
            btnExcel.addEventListener('click', () => {
                window.open(excelUrl, '_blank');
            });
        }
    }

    async function cargarModalListado(id) {
        try {
            const res = await fetch(`/admin/documentos/${id}/listado-enviados`);
            if (!res.ok) return;
            const data = await res.json();

            // Render header con métricas + botón
            renderListadoHeader({
                documento: data.documento || null,
                envios: data.envios || [],
                destinatarios: data.destinatarios || null,
                meta: data.meta || null,
                pendientes: data.pendientes || []
            });

            // Render tabla de enviados
            const listEnviados = document.querySelector('#listadoEnviadosContainer');
            listEnviados.innerHTML = '';

            if (!data.envios || data.envios.length === 0) {
                listEnviados.innerHTML = '<p>No hay envíos registrados para este documento.</p>';
            } else {
                let htmlEnviados = `
                    <table class="tabla-enviados">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Destinatario</th>
                                <th>Rol</th>
                                <th>Email</th>
                                <th>Estado</th>
                                <th>Fecha envío</th>
                                <th>Leído</th>
                                <th>Rebote</th>
                            </tr>
                        </thead>
                        <tbody>
                `;

                data.envios.forEach((envio, index) => {
                    let estadoHtml = '';
                    if (envio.enviado == 1) {
                        estadoHtml = '<span title="Enviado correctamente">✅</span>';
                    } else if (envio.error_log) {
                        const errorEscaped = String(envio.error_log).replace(/"/g, '&quot;');
                        estadoHtml = `<span title="Error: ${errorEscaped}">❌</span>`;
                    } else {
                        estadoHtml = '<span title="En cola / enviándose en segundo plano" style="font-size: 13px;">⏳ <em>En cola</em></span>';
                    }

                    htmlEnviados += `
                        <tr>
                            <td>${index + 1}</td>
                            <td>${envio.destinatario_nombre || '-'}</td>
                            <td>${envio.user && envio.user.role ? envio.user.role.name : '-'}</td>
                            <td>${envio.destinatario_email || '-'}</td>
                            <td>${estadoHtml}</td>
                            <td>${envio.fecha_envio ?? '-'}</td>
                            <td>${envio.leido ? '✅' : '❌'}</td>
                            <td>${envio.rebote_tipo ? envio.rebote_tipo : '-'}</td>
                        </tr>
                    `;
                });

                htmlEnviados += '</tbody></table>';
                listEnviados.innerHTML = htmlEnviados;
            }

            // Render tabla de pendientes
            const listPendientes = document.querySelector('#listadoPendientesContainer');
            listPendientes.innerHTML = '';

            if (!data.pendientes_detalle || data.pendientes_detalle.length === 0) {
                listPendientes.innerHTML = '<p>No hay envíos pendientes para este documento.</p>';
            } else {
                let htmlPendientes = `
                    <table class="tabla-enviados">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Destinatario</th>
                                <th>Email</th>
                                <th>Rol</th>
                            </tr>
                        </thead>
                        <tbody>
                `;

                data.pendientes_detalle.forEach((pendiente, index) => {
                    htmlPendientes += `
                        <tr>
                            <td>${index + 1}</td>
                            <td>${pendiente.nombre || '-'}</td>
                            <td>${pendiente.email || '-'}</td>
                            <td>${pendiente.rol || '-'}</td>
                        </tr>
                    `;
                });

                htmlPendientes += '</tbody></table>';
                listPendientes.innerHTML = htmlPendientes;
            }

            // Si hay correos en proceso (en cola), auto-actualizar cada 4 segundos mientras el modal siga abierto
            if (data.meta && data.meta.en_proceso > 0) {
                clearTimeout(modalPollTimer);
                modalPollTimer = setTimeout(() => {
                    if (currentModalDocId === id) {
                        cargarModalListado(id);
                    }
                }, 4000);
            }
        } catch (err) {
            console.error('Error al cargar listado de envíos:', err);
        }
    }

    document.querySelectorAll('.openListadoEnviadosModal').forEach(btn => {
        btn.addEventListener('click', async () => {
            const id = btn.dataset.id;
            currentModalDocId = id;
            await cargarModalListado(id);
            document.getElementById('listModal').classList.remove('hidden');
        });
    });

    const closeModalBtn = document.getElementById('closeModalList');
    if (closeModalBtn) {
        closeModalBtn.addEventListener('click', () => {
            clearTimeout(modalPollTimer);
            modalPollTimer = null;
            currentModalDocId = null;
            document.getElementById('listModal').classList.add('hidden');
        });
    }
});
